import React from "react";
import Layout from "../../../components/layouts/Layout";
import { useTranslation } from "react-i18next";
import CategoriesSection from "../../../components/store/reusable/category/CategoriesSection";
import { useParams, useSearchParams } from "react-router-dom";
import UpdateStoreGeneral from "../../../components/store/update/UpdateStoreGeneral";
import UpdateStoreProfile from "../../../components/store/update/UpdateStoreProfile";
import UpdateStorePublicInformation from "../../../components/store/update/UpdateStorePublicInformation";
import UpdateOpiningHours from "../../../components/store/update/UpdateOpiningHours";
import DeleteStoreAccount from "../../../components/store/update/DeleteStoreAccount";
import UpdatePasswordStorePage from "../../../components/store/update/UpdateStorePassword";
import UpdateTaxAndRegisterForm from "../../../components/store/update/UpdateTaxAndRegisterForm";

function UpdateStore() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");

      const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;

    const c = numericStoreId ? [] : [{ id: "password", name: t("password") },{ id: "delete_account", name: t("delete_account")} ]

  const categories = [
    { id: "general", name: t("general") },
    { id: "profile", name: t("profile") },
    { id: "publicInformation", name: t("publicInformation") },
    { id: "openingHours", name: t("openingHours") },
    { id: "taxAndRegister", name: t("taxAndRegister") },
    ...c
  ];

  const selectedCategory = category ? category :  categories[0].id;

  const renderTabContent = () => {
    switch (selectedCategory) {
      case "delete_account":
      return <div>
        <DeleteStoreAccount/>
      </div>;
      case "general":
        return <div><UpdateStoreGeneral/></div>;
      case "profile":
        return <div><UpdateStoreProfile/></div>;
      case "publicInformation":
        return <div><UpdateStorePublicInformation/></div>;
        case "openingHours":
        return <div><UpdateOpiningHours/></div>;
          case "taxAndRegister":
        return <div><UpdateTaxAndRegisterForm/></div>;
      case "password":
        return <div className="p-4"><UpdatePasswordStorePage/></div>;
      default:
        return <div className="p-4">{t("select_category")}</div>;
    }
  };

  return (
    <Layout title={t("settings")} headline="">
      <CategoriesSection
        selectedCategory={selectedCategory}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={"add-offer"}
        buttonLabel="add_new_offer"
        showAdd={false}
        notShowAddButton={true}
        showAllLable={false}
      />

      {/* Tab Content */}
      <div className="mt-6">
        {renderTabContent()}
      </div>
    </Layout>
  );
}

export default UpdateStore;
